import { render, staticRenderFns } from "./UpdatedFicheProfessionel.vue?vue&type=template&id=1b06c133&scoped=true&"
import script from "./UpdatedFicheProfessionel.vue?vue&type=script&lang=js&"
export * from "./UpdatedFicheProfessionel.vue?vue&type=script&lang=js&"
import style0 from "./UpdatedFicheProfessionel.vue?vue&type=style&index=0&id=1b06c133&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b06c133",
  null
  
)

export default component.exports